import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useNavigate, useParams } from "react-router-dom";
import UserBasciDetailsComponent from "./component";
import { toastr } from "react-redux-toastr";

const UserBasicDetailsContainer = (props) => {
  const [basicRole, setBasicRole] = useState([]);
  const [updateUser, setUpdateUser] = useState();
  const [loading, setLoading] = useState();
  const [status, setStatus] = useState();
  const [details, setEditBasicDetails] = useState();
  const { userid } = useParams();
  const navigate = useNavigate();
  const [userStatus, setUserStatus] = useState('');
  const [userName, setUserName] = useState('');
  const [userRole, setUserRole] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userVerifiedStatus, setUserVerifiedStatus] = useState('');
  const [userEmployeeCode, setUserEmployeeCode] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    // Check if current user is admin from localStorage
    const userData = JSON.parse(localStorage.getItem("data"));
    if (userData && userData.user && userData.user.role_id === 1) {
      setIsAdmin(true);
    }
    EditBasicDetails();
  }, []);

  const handleButtonsUpdate = (e) => {
    const buttonValue = e.target.value;
    setUserStatus(buttonValue);
  };

  const handleButtonsVerification = (e) => {
    const buttonVarifiedValue = e.target.value;
    setUserVerifiedStatus(buttonVarifiedValue);
  };

  const logout = () => {
    localStorage.removeItem("allPermissions");
    localStorage.removeItem("data");
    window.location.href = "/";
  };

  const EditBasicDetails = () => {
    return props.getDataFromAPI(
      `/dashboard/api/v2/admin/users/details?userId=${userid}`,
      "GET",
      undefined,
      (response) => {
        setLoading(false);
        setEditBasicDetails(response.userDetails);
        setUserStatus(response.userDetails.status);
        setUserName(response.userDetails.full_name);
        setUserRole(response.userRole.role_id);
        setUserEmail(response.userDetails.email);
        setUserVerifiedStatus(response.userDetails.verificationStatus);
        setUserEmployeeCode(response.userDetails.employeeCode);
      },
      (err) => { },
      true
    ); 
  };

  useEffect(() => {
    props.getDataFromAPI(
      "/dashboard/api/v2/admin/users/roles/all",
      "GET",
      undefined,
      (response) => {
        setBasicRole(response.list);
      }
    );
  }, []);

  const handleUpdateUserName = (e) => {
    setUserName(e.target.value);
  };

  const handleUpdateUserEmployeeCode = (e) => {
    setUserEmployeeCode(e.target.value);
  };

  const handleUpdateUserRole = (roleId) => {
    if (!isAdmin) {
      toastr.error("Permission Denied", "Only Admin can change user roles");
      return;
    }
    setUserRole(roleId);
  };

  const handleUpdateUserEmail = (e) => {
    setUserEmail(e.target.value);
  };

  const UpdateUserApi = () => {
    // Check if non-admin is trying to change role
    if (!isAdmin && userRole !== details?.userRole?.role_id) {
      toastr.error("Permission Denied", "Only Admin can change user roles");
      return;
    }

    props.getDataFromAPI(
      `/dashboard/api/v2/admin/users/${userid}`,
      "PATCH",
      {
        fullName: userName,
        roleId: userRole,
        email: userEmail,
        status: userStatus,
        verificationStatus: userVerifiedStatus,
        employeeCode: userEmployeeCode
      },
      (response) => {
        setUpdateUser(response);
        setLoading(true);
        toastr.success("Details Updated");
        
        // Only logout if user is editing their own profile
        const userData = JSON.parse(localStorage.getItem("data"));
        if (userData && userData.user && userData.user.id === parseInt(userid)) {
          logout();
        } else {
          navigate("/home/users/list");
        }
      },
      (err) => {
        toastr.error(err.message);
      }
    );
  };

  return (
    <UserBasciDetailsComponent
      loading={loading}
      basicRole={basicRole}
      handleUpdateUserName={handleUpdateUserName}
      handleUpdateUserRole={handleUpdateUserRole}
      handleUpdateUserEmail={handleUpdateUserEmail}
      updateUser={updateUser}
      UpdateUserApi={UpdateUserApi}
      handleButtonsUpdate={handleButtonsUpdate}
      status={status}
      basicdetails={details}
      userStatus={userStatus}
      userName={userName}
      userEmail={userEmail}
      userRole={userRole}
      handleButtonsVerification={handleButtonsVerification}
      userVerifiedStatus={userVerifiedStatus}
      handleUpdateUserEmployeeCode={handleUpdateUserEmployeeCode}
      userEmployeeCode={userEmployeeCode}
      isAdmin={isAdmin}
    />
  );
};

export default connect(
  (state) => ({}),
  { getDataFromAPI }
)(UserBasicDetailsContainer);